module.exports = __webpack_public_path__ + "static/media/Artboard7.6f7d664e.jpg";